import React, { Component } from 'react';

import './css/SelectQuestion.css';
import ArrayUtils from "../../utils/ArrayUtils";
import StringUtils from "../../utils/StringUtils";

class SelectQuestion extends Component {
    componentWillMount() {
        const options = this.props.options;
        if (this.props.shuffle) {
            for (let i = 0; i < options.length; i++) {
                ArrayUtils.shuffle(options[i]);
            }
        }
        let gapCount = 0;
        for (const subtask of this.props.subtasks) {
            gapCount += (subtask.match(/{%s}/g) || []).length;
        }
        const answers = new Array(gapCount).fill('');
        for (let i = 0; i < gapCount; i++) {
            answers[i] = options[i][0];
        }
        this.setState({ answers: answers, options: options });
        this.props.saveAnswer(this.props.id, answers);
    }

    handleChange = (number, event) => {
        const answers = this.state.answers;
        answers[number] = event.target.value;
        this.setState({ answers: answers });
        this.props.saveAnswer(this.props.id, answers);
    }

    render() {
        let gapIndex = 0;
        const subtasks = this.props.subtasks.map((subtask, taskIndex) => {
            const content = subtask
                .split("{%s}")
                .map((item, index, array) => {
                    const key = "gap-" + taskIndex + "-" + index;
                    if (index < array.length - 1) {
                        const gap = gapIndex;
                        gapIndex += 1;
                        let optionIndex = 0;
                        const options = this.state.options[gap].map(option => (<option key={"option-" + gap + "-" + optionIndex++} value={option}>{option}</option>))
                        return (
                            <span key={key}>{StringUtils.parse(item)}
                                <select
                                    className="select"
                                    value={this.state.answers[gap]}
                                    onChange={(event) => this.handleChange(gap, event)}>
                                    {options}
                                </select>
                            </span>)
                    }
                    return (<span key={key}>{StringUtils.parse(item)}</span>);
                });

            return (
                <div key={"subtask-" + taskIndex} className="subtask">
                    {content}
                </div>
            );
        });

        return (
            <div className="task-block select-question">
                <div className="question-number">Pytanie {this.props.questionNumber}</div>
                <div className="question">{StringUtils.parse(this.props.question)}</div>
                <div className="subtasks">
                    {subtasks}
                </div>
            </div>
        );
    }
}

export default SelectQuestion;
